import { Action, createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import { User } from '../../models/user';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';


export interface State extends EntityState<User> {
  user: User | undefined;
}

export interface State extends EntityState<User> {
  user: User | undefined;
}

export const adapter: EntityAdapter<User> = createEntityAdapter<User>();

export const initialState: State = adapter.getInitialState({
  user: undefined,
});


const userReducer = createReducer(
  initialState,
  on(UserActions.getUser, (state) =>  state),
  on(UserActions.getUserSuccess, (state, { user }) => {
    return { ...state, user };
  }),
  on(UserActions.getUserFailure, (state, { error }) => {
    return state;
  }),
  on(UserActions.loadUsers, (state) => {
    return state;
  }),
  on(UserActions.loadUsersSuccess, (state, { users }) => {
    return adapter.setAll(users, state);
  }),
  on(UserActions.loadUsersFailure, (state, { error }) => {
    return state;
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return userReducer(state, action);
}
